import { TripProviderTypes } from '../../lib/types/models/trip-provider/trip-provider'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTripProvider(data: TripProviderTypes.Input) {
  return restApiClient
    .url(constructApiUrl(API.tripProviders.create.url, null))
    .post<TripProviderTypes.Full, TripProviderTypes.Input>(data)
}
